import React, { useContext, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import Icon from '@ant-design/icons';
import { Modal } from 'antd';

import { isSllrUser } from 'utils/helpers';
import { sendSegment } from 'utils/segment';
import { ContextWrapper } from 'contexts/wrapper.context';
import { useModal } from 'contexts/modalProvider.context';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as CallIcon } from 'assets/bosta-icons/call.svg';
import { ReactComponent as CloseIcon } from 'assets/bosta-icons/Close.svg';

import './BookCall.less';

const CalendlyModal = ({ intl, close, onCloseModal, ...props }) => {

  useEffect(() => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.setAttribute(
      'src',
      'https://assets.calendly.com/assets/external/widget.js'
    );
    head.appendChild(script);
  }, []);

  const handleClose = () => {
    onCloseModal();
    close();
  };
  return (
    <Modal
      className="br-book-call__modal"
      title={
        <CloseIcon className="br-book-call__close" onClick={handleClose} />
      }
      footer={null}
      {...props}
      maskClosable
      onCancel={handleClose}
    >
      <div
        className="calendly-inline-widget"
        data-url={
          isSllrUser()
            ? 'https://docs.google.com/forms/d/e/1FAIpQLScpvaDJWmBh3Paxl6barjOG8gD0KzCpDTdYGwR-7EAWq47oaA/viewform?embedded=true" style="min-width:320px;height:630px;'
            : 'https://docs.google.com/forms/d/e/1FAIpQLScpvaDJWmBh3Paxl6barjOG8gD0KzCpDTdYGwR-7EAWq47oaA/viewform?embedded=true" style="min-width:320px;height:630px;'
        }
      />
    </Modal>
  );
};

const BookCall = ({
  intl,
  segmentSource,
  onOpenModal = () => {},
  onCloseModal = () => {}
}) => {
  const { businessInfo } = useContext(ContextWrapper);
  const { openModal } = useModal();

  return businessInfo.bankInfo ? (
    <div className="br-book-call">
      <span className="br-book-call__help">
        {intl.formatMessage({
          id: 'book_call.need_help'
        })}
      </span>
      <BRButton
        prefixIcon={<Icon component={CallIcon} className="ant-icon-md" />}
        className="link-color button"
        label={intl.formatMessage({
          id: 'book_call.schedule'
        })}
        onClick={() => {
          onOpenModal();
          segmentSource &&
            sendSegment('Book_a_call', { Source: segmentSource });
          openModal(CalendlyModal, { onCloseModal });
        }}
      />
    </div>
  ) : (
    <></>
  );
};

export default injectIntl(BookCall);
